import styled from "styled-components";

export const MainStyle = styled.main`
  max-width: 1500px;
  margin: 0 auto;
`;
